import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import {
    CompanyAdminUserGroupsQuery,
    UserGroupsForCompanyResponse,
    fetchUserGroupsForCompany,
} from "../../userGroups/userGroupsApi"
import { useCurrentCompany } from "../../../../hooks/useCurrentCompany"

export const ALL_USER_GROUPS = 0

const useStyles = makeStyles()(() => ({
    input: {
        minWidth: "12rem",
    },
}))

const selectUserGroupOptions = (data: UserGroupsForCompanyResponse) =>
    data.userGroups.map((group) => ({ id: group.id, name: group.name }))

type SelectUserGroupDropdownProps = Readonly<{
    userGroupId: number
    setUserGroupId: (userGroupId: number) => void
}>

export function SelectUserGroupDropdown({ userGroupId, setUserGroupId }: SelectUserGroupDropdownProps) {
    const { classes } = useStyles()
    const { companyId } = useCurrentCompany()

    const userGroupsResult = useApiQuery(fetchUserGroupsForCompany, {
        queryName: CompanyAdminUserGroupsQuery.LIST,
        dependencies: { companyId },
        select: selectUserGroupOptions,
    })

    const userGroups = userGroupsResult.data ?? []

    return (
        <FormControl className={classes.input} size="small">
            <LocalizedStrict id="company-organization-users-table-header-select-label-user-group">
                <InputLabel id="user-group-select-label">User Group</InputLabel>
            </LocalizedStrict>
            <Select
                labelId="user-group-select-label"
                id="user-group-select"
                value={String(userGroupId)}
                label="User Group"
                onChange={(event) => setUserGroupId(Number(event.target.value))}
            >
                <MenuItem value={String(ALL_USER_GROUPS)}>
                    <LocalizedStrict id="company-organization-users-table-header-select-item-all">
                        <span>All</span>
                    </LocalizedStrict>
                </MenuItem>
                {userGroups.map((group) => (
                    <MenuItem key={group.id} value={String(group.id)}>
                        {group.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
